import React, {memo, useEffect, useState} from "react";
import {TextField} from "@mui/material";
import Loading from "../Loading";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import {toast} from "react-toastify";

import {Paper} from "@mui/material";
import {useDispatch} from "react-redux";
import Api from "../../utils/api";
import {UserAutocomplete} from "../index";
import MarketerList from "../marketerList/marketerList";
import {useParams} from "react-router-dom";

const AncestryChange = (props) => {


    const {id} = props;

    const dispatch = useDispatch();
    const param = useParams()
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({})


    const handleSubmit = (event) => {

        event.preventDefault();

        let obj = {
            "form": "marketer_parent_update",
            "id": param.id,
            "parent_id": form.parent_id
        }

        setLoading(true);

        new Api().patch('/marketers/parent', obj , false).then((response) => {
            if (typeof response !== "undefined") {
                if (response.status === true) {
                    toast.success('تغییرات با موفقیت اعمال شد.');
                } else {
                    toast.error(response.msg);
                }

                setLoading(false);
            }

        })
    };


    const handleChangeSearchInputWithAutoComplete = (name, value) => {

        let frm = form;
        frm[name] = value;
        setForm({...frm});

    }


    return (
        <React.Fragment>
            <Paper className={'profile-form'}>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <MarketerList label={'بالاسری جدید'} onChange={(e) => handleChangeSearchInputWithAutoComplete("parent_id" , e.id)}/>
                        </Grid>
                        <Grid item xs={12}>
                            <Button type={"submit"} disabled={loading} color={"primary"} variant={"contained"}>ویرایش
                                اطلاعات</Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
            {loading && <Loading/>}
        </React.Fragment>
    );

}


export default memo(AncestryChange);